const AUTH_STORAGE_KEYS = ['token-id', 'userId', 'username', 'roleName', 'teacherId'];

let isRedirectingToLogin = false;

export const clearAuthStorage = () => {
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
};

export const isAuthErrorStatus = (status) => status === 401;

export const endExpiredSession = () => {
  clearAuthStorage();

  if (typeof window === 'undefined' || isRedirectingToLogin) {
    return;
  }

  isRedirectingToLogin = true;

  if (window.location.pathname !== '/login') {
    window.location.replace('/login');
  }
};
